<script setup>
import { ref, inject } from 'vue';
import { AxiosAPI } from '@/axios';
import { useMainStore } from '../../../stores/index';
import ModalOverlay from './ModalOverlay.vue';

const Store = useMainStore();
const emitter = inject('emitter');

const viewDocument = ref(null);
const id = ref(0);
const date = ref('');
const isSubmitting = ref(false);

const openModalCopy = (value) => {
  id.value = value;
  date.value = '';
  if (viewDocument.value) viewDocument.value.openModal();
};

const copy = () => {
  if (isSubmitting.value) return;

  isSubmitting.value = true;

  AxiosAPI.post(`/api/tasks/${id.value}/duplicate`, {
    date: date.value
  }, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Store.accessToken}`
    }
  }).then(() => {
    if (emitter) {
      emitter.emit('KanbanUpdated');
    }
    if (viewDocument.value) viewDocument.value.closeModal();

    id.value = 0;
    date.value = '';
  }).catch(error => {
    console.error('Erro ao duplicar tarefa:', error);
  }).finally(() => {
    isSubmitting.value = false;
  });
};

defineExpose({
  openModalCopy
});
</script>

<template>
  <div>
    <ModalOverlay ref="viewDocument">
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <span class="font-docs"><b>Copiar tarefa</b></span>
          </div>
          <div>
            <button
              id="close"
              type="button"
              class="close"
              @click="viewDocument.closeModal()"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </template>

      <template #body>
        <div>
          <label class="font-docs mb-2">Informe a data para a qual a tarefa será copiada:</label>
          <input type="date" class="my_form" v-model="date">
        </div>
      </template>

      <template #footer>
        <div class="d-flex justify-content-end mt-4">
          <button class="btn Color-Docs font-docs mr-3" style="border: 1px solid #F1860B" @click="viewDocument.closeModal()">
            Cancelar
          </button>
          <button class="btn background-Docs text-white font-docs" @click="copy" :disabled="isSubmitting">
            {{ isSubmitting ? 'Copiando...' : 'Continuar' }}
          </button>
        </div>
      </template>
    </ModalOverlay>
  </div>
</template>